import { ControlledCamera } from "@components/ControlledCamera";
import { Lighting } from "@components/Lighting";
import { Models } from "@components/Models";
import PointerView from "@components/PointerView";
import { DeviceProps } from "@components/Root";
import { useViewport } from "@components/ViewportManager";
import { useContext, useEffect } from "react";
import { LoadingContext } from "@components/Loader";

export function Scene(props: DeviceProps) {
    const view = useViewport<HTMLDivElement>("main");
    return (
        <PointerView ref={view}>
            
            <ControlledCamera {...props} />
            <Lighting />
            <Models {...props} />
            <Load />
        </PointerView>
    );
}

function Load() {
    const { setLoaded } = useContext(LoadingContext);
    useEffect(() => {
        setLoaded?.(true);
    }, [setLoaded]);
    return (<></>);
}